import { useState } from "react";
import { bloggers } from "@/mocks/portalData";

const filters = ["全部", "文娱八卦", "明星艺人", "科技数码", "品牌商业", "体娱赛场", "生活方式"];
const catLabel: Record<string, string> = {
  ent: "文娱八卦",
  celeb: "明星艺人",
  tech: "科技数码",
  brand: "品牌商业",
  sports: "体娱赛场",
  life: "生活方式",
};

export default function Bloggers() {
  const [filter, setFilter] = useState("全部");
  const [followed, setFollowed] = useState<number[]>([]);

  const list = bloggers.filter((b) => filter === "全部" || catLabel[b.category] === filter);

  const toggle = (id: number) =>
    setFollowed((f) => (f.includes(id) ? f.filter((x) => x !== id) : [...f, id]));

  return (
    <section id="bloggers" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-sm font-medium text-primary-600">认证账号库 · ACCOUNTS</p>
            <h2 className="mt-1 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              大V红人爆料账号推荐
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              各领域持续产出、认证信息完整的高影响力账号，方便你快速建立自己的「信息来源列表」。
            </p>
          </div>
          <div className="flex items-center gap-1 self-start rounded-full bg-background-100 p-1 md:self-auto">
            {filters.map((f) => (
              <button
                key={f}
                onClick={() => setFilter(f)}
                className={`whitespace-nowrap rounded-full px-3 py-1.5 text-sm font-medium transition-colors md:px-4 ${
                  filter === f ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:bg-background-200/70"
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((b) => {
            const isFollowed = followed.includes(b.id);
            return (
              <article key={b.id} className="flex flex-col rounded-xl border border-background-200/70 bg-background-100/60 p-5">
                <div className="flex items-start justify-between gap-2">
                  <div className="flex items-center gap-3">
                    <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-2xl text-primary-600">
                      <i className={b.icon}></i>
                    </span>
                    <div>
                      <div className="flex items-center gap-1.5">
                        <h3 className="font-heading text-base font-bold text-foreground-950">{b.display}</h3>
                        {b.hot && (
                          <span className="flex h-4 items-center whitespace-nowrap rounded-full bg-primary-500 px-1.5 text-[10px] font-bold text-background-50">
                            热
                          </span>
                        )}
                      </div>
                      <p className="mt-0.5 text-xs text-foreground-500">{b.handle}</p>
                    </div>
                  </div>
                  <button
                    onClick={() => toggle(b.id)}
                    className={`flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                      isFollowed
                        ? "bg-secondary-500 text-background-50"
                        : "bg-primary-500 text-background-50 hover:bg-primary-600"
                    }`}
                  >
                    <i className={`${isFollowed ? "ri-check-line" : "ri-add-line"} text-sm`}></i>
                    {isFollowed ? "已追踪" : "追踪"}
                  </button>
                </div>

                <p className="mt-4 flex items-center gap-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 rounded-full bg-background-50 px-2 py-0.5 text-primary-700">
                    <i className="ri-verified-badge-fill text-sm"></i>
                    {b.verified}
                  </span>
                </p>

                <p className="mt-2 line-clamp-3 text-sm leading-relaxed text-foreground-600">{b.intro}</p>

                <div className="mt-4 flex items-center justify-between border-t border-background-200/60 pt-3 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1.5">
                    <i className="ri-group-line text-sm text-accent-600"></i>
                    {b.followers} 粉丝
                  </span>
                  <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 font-medium text-accent-800">
                    {catLabel[b.category]}
                  </span>
                </div>
              </article>
            );
          })}
        </div>

        {list.length === 0 && (
          <div className="mt-8 flex items-center justify-center rounded-2xl bg-background-100 py-14 text-sm text-foreground-500">
            该领域暂无账号收录，欢迎推荐优质博主。
          </div>
        )}
      </div>
    </section>
  );
}